import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFView mb="-5px">
              <CFLink
                href="https://maps.app.goo.gl/AwuY7iy2xnBzrF13A"
                target="_blank"
              >
                <CFImage src={mobileMap} w="100%" alt="Sushi Valley" />
              </CFLink>
            </CFView>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              href="https://maps.app.goo.gl/AwuY7iy2xnBzrF13A"
              target="_blank"
            >
              <CFImage src={locationMap} w="100%" alt="Sushi Valley" />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
